import React from "react";

const TextInput = ({ field, label, id, multiline, className = "", icons, form: { touched, errors }, iconClass, showPassHandler, ...props }) => {
  return (
    <div className={`${className}`}>
      {label && (
        <label className="form-label" htmlFor={id}>
          {label}
        </label>
      )}
      {multiline ? (
        <textarea className={`form-control ${touched[field.name] && errors[field.name] && "error"}`} id={id} {...field} {...props}></textarea>
      ) : (
        <>
          {icons ? (
            <div className="input-group">
              <input
                className={`form-control ${touched[field.name] && errors[field.name] && "error"}`}
                id={id}
                type="text"
                {...field}
                {...props}
              />
              {showPassHandler ? (
                <span onClick={showPassHandler} style={{ cursor: "pointer" }} className="input-group-text">
                  <i class={`fa-regular fa-fw ${iconClass || "fa-eye"}`} />
                </span>
              ) : (
                <span className="input-group-text">
                  <i class={`fa-regular  fa-fw ${iconClass || "fa-envelope"}`} />
                </span>
              )}
            </div>
          ) : (
            <input
              className={`form-control ${touched[field.name] && errors[field.name] && "error"}`}
              id={id}
              type="text"
              {...field}
              {...props}
            />
          )}
        </>
      )}

      {touched[field.name] && errors[field.name] && <div className="errorMessage">{errors[field.name]}</div>}
    </div>
  );
};

export default TextInput;
